module.exports = __webpack_public_path__ + "img/ph.2e7a1efc.png";